var HistEntry = function HistEntry(c) {
  this.col = c;
  this.freq = 1;
};

HistEntry.prototype = {
  constructor: HistEntry,
  compareTo: function compareTo(entry) {
    return parseInt(entry.freq - this.freq, 10);
  },
  getColor: function getColor() {
    return this.col;
  },
  getFrequency: function getFrequency() {
    return this.freq;
  }
};
module.exports = HistEntry;